// Components
import Heading from '@/components/atoms/Heading/Heading';
import Button from '@/components/atoms/Button/Button';
import PreTitle from '@/components/atoms/PreTitle/PreTitle';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Other
import { type BlocListeMediaType } from '@/services/blocksSchema';
import VectorDark from '@/assets/blocks/vector-shadow-dark.svg?react';
import VectorRed from '@/assets/blocks/vector-shadow-red.svg?react';

// Style
import styles from './BlocListeMedia.module.css';

interface BlocListeMediaProps {
  preTitle?: BlocListeMediaType['preTitle'];
  title: BlocListeMediaType['title'];
  description?: BlocListeMediaType['description'];
  image: BlocListeMediaType['image'];
  imagePosition: BlocListeMediaType['imagePosition'];
  sections?: BlocListeMediaType['sections'];
  button?: BlocListeMediaType['button'];
}

function BlocListeMedia({
  preTitle = null,
  title,
  description = null,
  image,
  imagePosition,
  sections = null,
  button = null,
}: BlocListeMediaProps) {
  return (
    <div className={styles.relative}>
      <VectorDark />
      <div className={styles.container}>
        <div
          className={`
            ${styles.body}
            ${imagePosition === 'Gauche' ? styles['image-left'] : styles['image-right']}
          `}
        >
          <CmsImage
            media={image}
            sizes="50vw"
            className={styles.image}
          />
          
          <div className={styles.content}>
            <div className={styles['content-header']}>
              {
                preTitle ? (
                  <PreTitle preTitle={preTitle} />
                ) : null
              }
              <Heading
                title={title}
                color='dark'
                size='h2'
                Tag='h2'
              />
            </div>
            {
              description ? (
                <p className={styles.description}>
                  {description}
                </p>
              ) : null
            }
            {
              sections ? (
                <div className={styles.sections}>
                  {
                    sections.map((section) => (
                      <div key={section.title} className={styles.section}>
                        <div className={styles['section-title']}>
                          {
                            section.icon ?  (
                              <CmsImage media={section.icon} sizes="38px" width={38} height={38} />
                            ) : null
                          }
                          {
                            section.title ? (
                              <p>
                                {section.title}
                              </p>
                            ) : null
                          }      
                        </div>
                        {
                          section.description ? (
                            <p className={styles['section-description']}>
                              {section.description}
                            </p>
                          ) : null
                        }       
                      </div>
                    ))
                  }
                </div>
              ) : null
            }
            {
              button ? (
                <Button
                  title={button.title}
                  url={button.url}
                  bgColor='red'
                />
              ) : null
            }
          </div>
        </div>
      </div>
      <div className={styles['vector-red']}>
        <VectorRed />
      </div>
    </div>
  );
}

export default BlocListeMedia;
